/**
 * Découpage de texte en lignes / mots / caractères pour les animations
 * d'apparition (voir src/sass/components/_reveal.scss et
 * src/js/components/Reveal/Reveal.js). Aucune dépendance externe.
 *
 * Ne s'applique qu'à du texte brut : chaque fonction lit el.textContent et
 * réécrit el.innerHTML avec le découpage — tout HTML existant (gras,
 * italique, liens, <br>...) serait perdu. Pour du contenu riche, préférer
 * l'animation "fade" (voir _reveal.scss), qui ne touche pas au HTML.
 */

function escapeHtml (str) {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

export function splitWords (el) {
  const words = el.textContent.trim().split(/\s+/)
  el.innerHTML = words
    .map((word, i) => `<span class="reveal-word-mask"><span class="reveal-word" style="--i:${i}">${escapeHtml(word)}</span></span>`)
    .join(' ')
}

export function splitChars (el) {
  const words = el.textContent.trim().split(/\s+/)
  let i = 0
  el.innerHTML = words
    .map(word => {
      const chars = word
        .split('')
        .map(char => `<span class="reveal-char-mask"><span class="reveal-char" style="--i:${i++}">${escapeHtml(char)}</span></span>`)
        .join('')
      return `<span class="reveal-word-mask">${chars}</span>`
    })
    .join(' ')
}

/**
 * Découpe par ligne visuelle (pas juste par <br>) : on mesure où le texte
 * casse réellement à l'écran. Comme le rendu dépend de la largeur du
 * conteneur, on garde le texte d'origine (data-reveal-original) pour
 * pouvoir re-découper au resize (voir Reveal.js).
 */
export function splitLines (el) {

  const original = el.dataset.revealOriginal || el.textContent.trim()
  el.dataset.revealOriginal = original

  const words = original.split(/\s+/)
  el.innerHTML = words.map(word => `<span class="reveal-line-word">${escapeHtml(word)}</span>`).join(' ')

  const wordEls = Array.from(el.querySelectorAll('.reveal-line-word'))
  const lines = []
  let currentTop = null

  wordEls.forEach(wordEl => {
    const top = Math.round(wordEl.offsetTop)
    if (top !== currentTop) {
      currentTop = top
      lines.push([])
    }
    lines[lines.length - 1].push(wordEl.textContent)
  })

  el.innerHTML = lines
    .map((lineWords, i) => `<span class="reveal-mask"><span class="reveal-line" style="--i:${i}">${escapeHtml(lineWords.join(' '))}</span></span>`)
    .join('')
}
